import { Inject } from '@odinjs/odin';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ModalService, PanelAPI, RadioGroupAPI, SelectableItem } from '@philips-internal/oswald-ui-components';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import Controller, { OnBeforeSubmit, OnCancel, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';

import BaseController from '../../BaseController';
import './pd-pain-scale-controller.css';
import { Endpoint } from '../../../constants/endpoints';
import { FragmentNames, PdPainScaleAliases } from '../../../codegen';

@Controller({ fragment: FragmentNames.PD_PAIN_SCALE })
class PdPainScaleController extends BaseController {

  @Inject(PdPainScaleAliases.REFERENCE_MODAL)
  panelLoaderModalApi!: PanelAPI;

  @Inject(PdPainScaleAliases.VIB_RADIO_GROUP)
  vibRadioGroupApi!: RadioGroupAPI;

  @Inject(PdPainScaleAliases.FACIAL_EXPRESSION_RADIO_GROUP)
  facialExpressionRadioGroupApi!: RadioGroupAPI;

  @Inject(PdPainScaleAliases.COMFORT_RADIO_GROUP)
  comfortRadioGroupApi!: RadioGroupAPI;

  @Inject(PdPainScaleAliases.NEGATIVE_VOCALIZATION_RADIO_GROUP)
  negativeVocalizationRadioGroupApi!: RadioGroupAPI;

  @Inject(PdPainScaleAliases.BODY_LANGUAGE_RADIO_GROUP)
  bodyLanguageRadioGroupApi!: RadioGroupAPI;

  @OnMount({ target: PdPainScaleAliases.VIB_RADIO_GROUP})
  onMountVibForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.pdPainScaleRadioGroup(335938, radioGroup);
  }

  @OnMount({ target: PdPainScaleAliases.FACIAL_EXPRESSION_RADIO_GROUP})
  onMountFacialExpressionForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.pdPainScaleRadioGroup(335940, radioGroup);
  }

  @OnMount({ target: PdPainScaleAliases.COMFORT_RADIO_GROUP})
  onMountComfortForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.pdPainScaleRadioGroup(335942, radioGroup);
  }

  @OnMount({ target: PdPainScaleAliases.NEGATIVE_VOCALIZATION_RADIO_GROUP})
  onMountNegativeVocalizationForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.pdPainScaleRadioGroup(335939, radioGroup);
  }

  @OnMount({ target: PdPainScaleAliases.BODY_LANGUAGE_RADIO_GROUP})
  onMountBodyLanguageForm(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.pdPainScaleRadioGroup(335941, radioGroup);
  }

  @OnClose({ target: PdPainScaleAliases.MODAL_PAIN_SCALE_REFERENCE})
  onCloseModal(): void {
    this.panelLoaderModalApi.setVisible(false);
  }

  @OnClick({ target: PdPainScaleAliases.REFERENCE_LINK})
  onClickReference(): void {
    this.panelLoaderModalApi.setVisible(true);
  }

  @OnCancel({ target: PdPainScaleAliases.VIB_FORM})
  onClickCancel(): void {
    ModalService.close(FragmentNames.PD_PAIN_SCALE);
  }

  @OnBeforeSubmit({ target: PdPainScaleAliases.VIB_FORM})
  onBeforeSubmitForm(): void {
    const setPainScaleValue = this.context.get('setPainScaleValue');
    setPainScaleValue(Number(this.vibRadioGroupApi?.getValue()?.value)
                   + (Number(this.facialExpressionRadioGroupApi?.getValue()?.value))
                   + (Number(this.comfortRadioGroupApi?.getValue()?.value))
                   + (Number(this.negativeVocalizationRadioGroupApi?.getValue()?.value))
                   + (Number(this.bodyLanguageRadioGroupApi?.getValue()?.value)));
    ModalService.close(FragmentNames.PD_PAIN_SCALE);
  }

  pdPainScaleRadioGroup(expressionId:number, radioGroup:RadioGroupAPI) :void{
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();

    HttpService.get(Endpoint.GET_PAIN_SCALE_DATA, {encounterId, expressionId, patientId})
      .then(response => {
        if(response) {
          const responseBody = response.body as SelectableItem[];
          radioGroup.setData(responseBody);
          radioGroup.setValue(responseBody[0]);
        }
      });
  }
}
export default PdPainScaleController;
